import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import FormHospitalCreate from '../../../../components/user/FormHospitalCreate'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class FormCreateHospital extends Component {
	state = {
        dataForm:[]
	}

    fetchData = async () =>{
        this.setState({
            dataForm:"1"
        })
    }

	onSubmit = async (values) => {
        const { form, afterSubmit, client } = this.props
        const { telNo, otpToken, refCode } = this.state
        window.location.href = '/hospital/Withdraw/1'

		// form.validateFields(async (err, values) => {
		// 	if (!err) {
        //         try {
                    
        //             const { data, errors } = await client.mutate({
        //                 mutation: Mutations.changePhoneNumber,
        //                 variables: {
        //                     telNo,
        //                     otp:{
        //                         otpToken: otpToken,
        //                         refCode: refCode,
        //                         otpCode: values.otp
        //                     }
        //                 }
        //             })

        //             console.log(data)

        //             if(data){
        //                 message.success("ส่งเพื่อดำเนินการเรียบร้อย")
        //                 setTimeout(() => {
        //                     window.location.reload();
        //                 }, 600);
        //             }
        //         }catch (error) {
                    
        //         }
		// 	}
		// })
	}

    
	async componentDidMount(){
        const { match, location } = this.props
        if(location.pathname.split('/')[3]){
            this.fetchData();
        }
        console.log(location.pathname.split('/')[3])
    }

	render() {
		const { match, location } = this.props
		const { dataForm } = this.state
        const { getFieldDecorator } = this.props.form
        // console.log(dataForm)
		return (
			<Container match={match}>
				{
					dataForm &&
					    <FormHospitalCreate autoFocus afterSubmit={this.onSubmit} post={dataForm}/>
                    ||
					    <FormHospitalCreate autoFocus afterSubmit={this.onSubmit} post={dataForm}/>
				}
			</Container>
		)
	}
}

FormCreateHospital.defaultProps = {
	autoFocus: false
}

FormCreateHospital.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedFormCreateHospital = Form.create()(FormCreateHospital)

export default withApollo(WrappedFormCreateHospital)